<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-avatar >
        <img 
        [defaultImage]="assetLinksService.avatarLoading" 
        [lazyLoad]="shop.logo" 
        [errorImage]="assetLinksService.noImage"/>
      </ion-avatar>
    </ion-buttons>
    <ion-title>{{shop.name}}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="return(shop)" >
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  
  </ion-toolbar>
</ion-header>

<ion-content>
  <swiper 
    #swiper 
    direction="horizontal"
    [pagination]="{
      type: 'progressbar',
    }"
    class="ion-content-scroll-host"
    (swiper)="onSwiper($event)"
    (beforeTransitionStart)="onBeforeTransitionStart($event)"
    >
  <ng-template swiperSlide *ngFor="let coupon of coupons">
    <ion-card class="pic-card"  >
      <img 
      class="fade-in"
      [defaultImage]="assetLinksService.cardLoading" 
      [lazyLoad]="coupon.picture" 
      [errorImage]="assetLinksService.noImage"/>
      <ion-fab vertical="bottom" horizontal="end" >
        <ion-fab-button
        paystack
        [paystackOptions]="paystackOptions"
        (paymentInit)="paymentInit()"
        (onClose)="paymentCancel()"
        (callback)="paymentDone($event)"
        >
          <ion-icon *ngIf="!linkClickThinking; else spinner" name="card"></ion-icon>
          <ng-template #spinner>
            <ion-spinner name="circular"></ion-spinner>
          </ng-template>
        </ion-fab-button>
      </ion-fab>
    </ion-card>
  
    <ion-card  class="desc-card">
      <ion-card-header>
        <ion-card-title>{{coupon.name}}</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        {{coupon.description}}
      </ion-card-content>
    </ion-card>
  
  </ng-template>
</swiper>
</ion-content>